/* eslint-disable prettier/prettier */
import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { List, Typography, Divider } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
    const theme = useTheme();

    // menu list collapse & items
    const items = item.children?.map((menu) => {
        switch (menu.type) {
            case 'collapse':
                return <NavCollapse key={menu.id} menu={menu} level={1} />;
            case 'item':
                return <NavItem key={menu.id} item={menu} level={1} />;
            default:
                return (
                    <Typography key={menu.id} variant="h6" color="error" align="center">
                        NavGroup Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <>
            <List
                style={{ marginTop: '10px !important' }}
                subheader={
                    item.title && (
                        <Typography
                            variant="caption"
                            sx={{
                                ...theme.typography.menuCaption,
                                color: '#000',
                                fontFamily: 'Open Sans',
                                fontSize: '22px',
                                fontStyle: 'normal',
                                fontWeight: 'bold',
                                lineHeight: 'normal',
                                marginLeft: '15px'
                            }}
                            display="block"
                            gutterBottom
                        >
                            <Divider className="MarginTop2px MarginBottom10px" />
                            {/* <Divider sx={{ mt: 0.25, mb: 1.25 }} /> */}
                            {item.caption && (
                                <Typography
                                    variant="caption"
                                    sx={{
                                        ...theme.typography.subMenuCaption,
                                        color: ' #808080',
                                        fontFamily: 'Open Sans',
                                        fontSize: '18px',
                                        fontStyle: 'normal',
                                        fontWeight: '400',
                                        lineHeight: 'normal'
                                    }}
                                    display="block"
                                    gutterBottom
                                >
                                    {item.caption}
                                </Typography>
                            )}
                        </Typography>
                    )
                }
            >
                {items}
            </List>
        </>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;
